import { Mark } from "../Logo";
import { MaskLines, FadeUp } from "../Reveal";

const stats = [
  { n: "05", l: "Ventures" },
  { n: "03", l: "Businesses" },
  { n: "02", l: "Charities" },
];

export const About = () => {
  return (
    <section id="about" data-testid="about-section" className="bg-bone px-5 py-24 text-ink md:px-10 md:py-36">
      <div className="mx-auto grid max-w-[1500px] gap-14 lg:grid-cols-12 lg:gap-20">
        <FadeUp className="lg:col-span-6 lg:self-center">
          <div data-testid="about-portrait" className="group relative aspect-[1447/1087] overflow-hidden rounded-[28px] bg-ink">
            <img
              src="/images/jeremy.jpg"
              alt="Jeremy Spear in his office"
              className="absolute inset-0 h-full w-full object-contain transition-transform duration-700 group-hover:scale-[1.02]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-ink/70 via-transparent to-transparent" />
            <div className="absolute inset-x-5 bottom-5 flex items-center justify-between font-mono text-[11px] uppercase tracking-[0.2em] text-bone/90">
              <span>Jeremy Spear</span>
              <Mark className="h-6 w-6 text-ember" />
            </div>
          </div>
        </FadeUp>
        <div className="lg:col-span-6 lg:pt-10">
          <p className="eyebrow text-cobalt">About</p>
          <h2 className="mt-6 font-display text-4xl font-extrabold uppercase leading-[0.95] tracking-tight sm:text-5xl lg:text-6xl">
            <MaskLines lines={["Hi, I'm Jeremy.", <span key="i" className="font-serif font-normal normal-case italic text-cobalt">Nice to meet you.</span>]} />
          </h2>
          <FadeUp delay={0.1} className="mt-10 max-w-2xl space-y-6 text-base leading-relaxed text-ink/80 md:text-lg">
            <p>
              I'm a serial entrepreneur. I start companies when I see people being underserved — whether that's someone trying to rebuild
              their credit, a family that wants a home built for the Gulf Coast, or a professional who keeps losing the contacts they meet.
            </p>
            <p>
              And I believe business should give back. That's why I started causes that put people first — because every person deserves
              to be considered.
            </p>
            <p data-testid="about-bio-1">
              I'm a Corpus Christi, Texas-based entrepreneur, business owner, and community advocate with a passion for building businesses,
              creating opportunities, and making a meaningful difference in the lives of others.
            </p>
            <p data-testid="about-bio-2">
              With more than 18 years of experience in real estate and over a decade in construction and project management, I have
              developed a diverse professional background spanning real estate, residential construction, financial services, printing,
              marketing, and business development.
            </p>
          </FadeUp>
          <div className="mt-14 grid grid-cols-3 border-t border-ink/15">
            {stats.map((s, i) => (
              <FadeUp key={s.l} delay={0.1 * i} className="border-r border-ink/15 pt-6 last:border-r-0 [&:not(:first-child)]:pl-5">
                <div data-testid={`about-stat-${s.l.toLowerCase()}`} className="font-display text-5xl font-extrabold tracking-tight md:text-7xl">{s.n}</div>
                <div className="mt-2 font-mono text-[11px] uppercase tracking-[0.2em] text-ink/65">{s.l}</div>
              </FadeUp>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
